import { jsx } from 'react/jsx-runtime';

const MoveIcon = ({
  size,
  color = "currentColor"
}) => {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.1 18.1",
    style: {
      width: `${(typeof size === "number" ? size : size.width).toString()}px`,
      height: `${(typeof size === "number" ? size : size.height).toString()}px`
    },
    children: /*#__PURE__*/jsx("path", {
      fill: "none",
      stroke: color,
      strokeWidth: "1",
      strokeLinecap: "round",
      vectorEffect: "non-scaling-stroke",
      d: "m7.1 3.1 2-2 2 2M11.1 15.1l-2 2-2-2M3.1 11.1l-2-2 2-2M15.1 7.1l2 2-2 2M9.1 2.1v13.8M2.2 9H16"
    })
  });
};

export { MoveIcon };
//# sourceMappingURL=MoveIcon.js.map
